import { render } from "./ItemCertificate.vue?vue&type=template&id=5b2b348a"
import script from "./ItemCertificate.vue?vue&type=script&lang=js"
export * from "./ItemCertificate.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__